// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabs-header {
  background-color: #ffffff;
  border-radius: 8px 8px 0 0;
  border: 1px solid #E4E7F0;
  border-bottom: 0;
}

.tabs {
  padding: 2rem 1.5rem 0;
}
.tabs a {
  padding: 8px 4px;
  border-bottom: 2px solid transparent;
  margin-right: 24px;
}
.tabs a:last-child {
  margin-right: 0;
}
.tabs a:hover h4 {
  color: #11BC97;
}

.tabs a.active {
  border-color: #11BC97;
}

.tabs a.active h4 {
  color: #11BC97;
}

.collapsable-form .additional-fields {
  display: none;
}

.collapsable-form.opened .custom-actions {
  display: none;
}

.collapsable-form.opened .additional-fields {
  display: block;
}

.collapsable-form.opened svg {
  transform: rotate(180deg);
}

.wallet-container {
  width: 320px;
}

.wallet-info__header {
  padding: 1.5rem;
}
.wallet-info__header img {
  margin-left: 15px;
}
.wallet-info__content {
  padding: 1.5rem 1.5rem 0;
}
.wallet-info__content li {
  padding: 6px 0;
}

.badge-risk {
  font-size: 11px !important;
  font-weight: 600 !important;
  text-transform: uppercase;
}

.wallet-summary {
  margin: 0;
}
.wallet-summary__item {
  padding: 15px 25px;
}
.wallet-summary__table {
  padding: 0;
}
.wallet-summary__table-body {
  max-height: 180px;
  overflow-y: scroll;
}
.wallet-summary__button {
  width: 100%;
  border: 0;
  background: 0;
}

.summary-col {
  width: 19%;
  text-align: right;
  padding: 8px 5px;
}
.summary-col:first-child {
  flex-shrink: 0;
  width: 12%;
  text-align: left;
}
.summary-col:nth-child(2) {
  width: 12%;
}

.w90px {
  max-width: 90px !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/realTimeScreen.scss","webpack://./src/styles/_colors.scss"],"names":[],"mappings":"AACA;EACE,yBCFY;EDGZ,0BAAA;EACA,yBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,sBAAA;AAAF;AACE;EACE,gBAAA;EACA,oCAAA;EACA,kBAAA;AACJ;AAAI;EACE,eAAA;AAEN;AAAI;EACE,cChBO;ADkBb;;AAGA;EACE,qBCtBW;ADsBb;;AAEA;EACE,cCzBW;AD0Bb;;AAEA;EACE,aAAA;AACF;;AACA;EACE,aAAA;AAEF;;AAAA;EACE,cAAA;AAGF;;AADA;EAEE,yBAAA;AAIF;;AADA;EACE,YAAA;AAIF;;AAAE;EACE,eAAA;AAGJ;AAFI;EACE,iBAAA;AAIN;AADE;EACE,wBAAA;AAGJ;AAFI;EACE,cAAA;AAIN;;AACA;EACE,0BAAA;EACA,2BAAA;EACA,yBAAA;AAEF;;AACA;EACE,SAAA;AAEF;AADE;EACE,kBAAA;AAGJ;AADE;EACE,UAAA;AAGJ;AADE;EACE,iBAAA;EACA,kBAAA;AAGJ;AADE;EACE,WAAA;EACA,SAAA;EACA,aAAA;AAGJ;;AACA;EACE,UAAA;EACA,iBAAA;EACA,gBAAA;AAEF;AADE;EACE,cAAA;EACA,UAAA;EACA,gBAAA;AAGJ;AADE;EACE,UAAA;AAGJ;;AACA;EACE,0BAAA;AAEF","sourcesContent":["@import './colors';\n.tabs-header {\n  background-color: $color-white;\n  border-radius: 8px 8px 0 0;\n  border: 1px solid $color-normalGrey;\n  border-bottom: 0;\n}\n\n.tabs {\n  padding: 2rem 1.5rem 0;\n  a {\n    padding: 8px 4px;\n    border-bottom: 2px solid transparent;\n    margin-right: 24px;\n    &:last-child {\n      margin-right: 0;\n    }\n    &:hover h4 {\n      color: $color-green;\n    }\n  }\n}\n\n.tabs a.active {\n  border-color: $color-green;\n}\n.tabs a.active h4 {\n  color: $color-green;\n}\n\n.collapsable-form .additional-fields {\n  display: none;\n}\n.collapsable-form.opened .custom-actions {\n  display: none;\n}\n.collapsable-form.opened .additional-fields {\n  display: block;\n}\n.collapsable-form.opened svg {\n  -webkit-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n\n.wallet-container {\n  width: 320px;\n}\n\n.wallet-info {\n  &__header {\n    padding: 1.5rem;\n    img {\n      margin-left: 15px;\n    }\n  }\n  &__content {\n    padding: 1.5rem 1.5rem 0;\n    li {\n      padding: 6px 0;\n    }\n  }\n}\n\n.badge-risk {\n  font-size: 11px !important;\n  font-weight: 600 !important;\n  text-transform: uppercase;\n}\n\n.wallet-summary {\n  margin: 0;\n  &__item {\n    padding: 15px 25px;\n  }\n  &__table {\n    padding: 0;\n  }\n  &__table-body {\n    max-height: 180px;\n    overflow-y: scroll;\n  }\n  &__button {\n    width: 100%;\n    border: 0;\n    background: 0;\n  }\n}\n\n.summary-col {\n  width: 19%;\n  text-align: right;\n  padding: 8px 5px;\n  &:first-child {\n    flex-shrink: 0;\n    width: 12%;\n    text-align: left;\n  }\n  &:nth-child(2) {\n    width: 12%;\n  }\n}\n\n.w90px {\n  max-width: 90px !important;\n}\n","$color-white: #ffffff;\n$color-black: #000000;\n$color-green:#11BC97;\n$color-secGreen:#0ead8a;\n$color-blue:#2091E9;\n$color-sharpGreen:#01FFCA;\n$color-pink:#E66A8B;\n$color-orange:#FB8C3D;\n$color-orange-high:#F4B717;\n$color-yellow:#FB8C3D;\n$color-purple:#A001FF;\n$color-light-purple:#7879F1;\n$color-darkBlue:#110133;\n$color-lightGrey:#F4F6FA;\n$color-normalGrey:#E4E7F0;\n$color-monoDullGrey:#A7B2CD;\n$color-monoNormalGrey:#636A7D;\n$color-light-blue:#a7b2cd;\n$color-monoIntenseGrey:#222735;\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
